export default __webpack_public_path__ + "static/media/screen6.dcaa7942.png";